import { createMenuTool } from "./createMenuTool"
import type { MenuNode } from "@/ui/EditorJsMenu"

type AIConfig = {
  registeredToolKeys?: string[]
  createPortal: any
  removePortal: any
  insertables: {
    attributionHighlights?: { toolName: string; label?: string; data?: any }
    liquidityEvents?: { toolName: string; label?: string; data?: any }
    newInvestments?: { toolName: string; label?: string; data?: any }
    cashFlows?: { toolName: string; label?: string; data?: any }
    highLevelSummary?: { toolName: string; label?: string; data?: any }
  }
}

const wandSparklesSvg = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.21 1.21 0 0 0 1.72 0L21.64 5.36a1.21 1.21 0 0 0 0-1.72Z"/>
  <path d="m14 7 3 3"/>
  <path d="M5 6v4"/>
  <path d="M19 14v4"/>
  <path d="M10 2v2"/>
  <path d="M7 8H3"/>
  <path d="M21 16h-4"/>
  <path d="M11 3H9"/>
</svg>`

export const AIContentTool = createMenuTool<AIConfig>({
  title: "AI Content",
  icon: wandSparklesSvg,
  buildMenu: ({ config, isAvailable }) => {
    const nodes: MenuNode[] = []

    const ah = config.insertables.attributionHighlights
    if (ah) {
      nodes.push({
        type: "action",
        icon: "wandSparkles",
        label: ah.label || "Attribution highlights",
        toolName: ah.toolName,
        data: ah.data,
        visible: isAvailable(ah.toolName),
      })
    }

    const le = config.insertables.liquidityEvents
    if (le) {
      nodes.push({
        type: "action",
        icon: "wandSparkles",
        label: le.label || "Liquidity Events",
        toolName: le.toolName,
        data: le.data,
        visible: isAvailable(le.toolName),
      })
    }

    const ni = config.insertables.newInvestments
    if (ni) {
      nodes.push({
        type: "action",
        icon: "wandSparkles",
        label: ni.label || "New Investments",
        toolName: ni.toolName,
        data: ni.data,
        visible: isAvailable(ni.toolName),
      })
    }

    const cf = config.insertables.cashFlows
    if (cf) {
      nodes.push({
        type: "action",
        icon: "wandSparkles",
        label: cf.label || "Cash Flows",
        toolName: cf.toolName,
        data: cf.data,
        visible: isAvailable(cf.toolName),
      })
    }

    const hls = config.insertables.highLevelSummary
    if (hls) {
      nodes.push({
        type: "action",
        icon: "wandSparkles",
        label: hls.label || "High Level Summary",
        toolName: hls.toolName,
        data: hls.data,
        visible: isAvailable(hls.toolName),
      })
    }

    return nodes
  },
})
